import styles from "./Header.module.css";
import ProfileWidget from "components/Navigation/ProfileWidget";
import StudentSelect from "components/Navigation/StudentSelect";
import Logo from "assets/USPA-logo.svg";

const Header = () => {
    return (
        <header className={styles.Header} data-testid="header">
            <StudentSelect />
            <ProfileWidget />
        </header>
    );
};

export default Header;
